const spaceTokens = {
  "space.2": 2,
  "space.4": 4,
  "space.6": 6,
  "space.8": 8,
  "space.10": 10,
  "space.12": 12,
  "space.16": 16,
  "space.20": 20,
  "space.24": 24,
  "space.30": 30,
  "space.32": 32,
  "space.34": 34,
  "space.40": 40,
  "space.80": 80
};
export { spaceTokens };
//# sourceMappingURL=space.tokens.mjs.map
